import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { resetPassword } from '../../utils/queries';
import AuthCard, { FormError, FormSuccess, PasswordField, PASSWORD_HINT, newPasswordSchema } from './AuthCard';

const ResetSchema = Yup.object().shape(newPasswordSchema);

export default function ResetPassword() {
	const [searchParams] = useSearchParams();
	const token = searchParams.get('token') || '';
	const email = searchParams.get('email') || '';
	const linkIsValid = Boolean(token && email);

	const [done, setDone] = useState('');

	const handleSubmit = async (values, { setSubmitting, setStatus }) => {
		setStatus(undefined);

		const response = await resetPassword({ email, token, password: values.password });
		setSubmitting(false);

		if (response?.error) {
			setStatus(response.error);
			return;
		}

		setDone(response?.data || 'Your password has been reset. You can now sign in.');
	};

	return (
		<AuthCard title='Choose a new password' subtitle={email || undefined}>
			{!linkIsValid && <FormError message='This password reset link is invalid or incomplete.' />}
			<FormSuccess message={done} />

			{linkIsValid && !done && (
				<Formik
					initialValues={{ password: '', confirmPassword: '' }}
					validationSchema={ResetSchema}
					onSubmit={handleSubmit}
				>
					{({ isSubmitting, status }) => (
						<Form className='space-y-4'>
							<FormError message={status} />
							<PasswordField name='password' label='New password' hint={PASSWORD_HINT} />
							<PasswordField name='confirmPassword' label='Confirm new password' />
							<button
								type='submit'
								disabled={isSubmitting}
								className='btn-primary disabled:opacity-50 disabled:cursor-not-allowed'
							>
								{isSubmitting ? 'Saving...' : 'Reset password'}
							</button>
						</Form>
					)}
				</Formik>
			)}

			<p className='text-center text-sm text-gray-600'>
				{done ? (
					<Link to='/login' className='text-pi-red hover:underline'>
						Sign in
					</Link>
				) : !linkIsValid ? (
					<Link to='/forgot-password' className='text-pi-red hover:underline'>
						Request a new link
					</Link>
				) : (
					<Link to='/login' className='text-pi-red hover:underline'>
						Back to sign in
					</Link>
				)}
			</p>
		</AuthCard>
	);
}
